import { DatePatternTable } from 'components/table/date_patterns/Table'

const DatePatterns = () => {
    return (
        <>
            <DatePatternTable />
        </>
    );
}

export { DatePatterns };